import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'nlf-resolve-lungo-country',
  templateUrl: './resolve-lungo-country.component.html',
  styleUrls: ['./resolve-lungo-country.component.css']
})
export class ResolveLungoCountryComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
